export default __webpack_public_path__ + "static/media/extruder.34359e86.svg";